import React, { FC, useEffect, useState } from 'react';

import { Button, Form, message, Modal, Select, TreeSelect } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { LayoutType } from '../../../../../types/LayoutType';
import { UpdateLayouts } from '../../../../../api/layout/UpdateLayout';
import { Option } from 'antd/lib/mentions';
import { useLayoutsStore } from '../../../../../store/layout/useLayoutsStore';
import { useDevicesStore } from '../../../../../store/devices/allDevices';
import { useAuthStore } from '../../../../../store/auth/auth';
import { Device } from '../../../../../types/Device';
import './styles.css';

interface AddDeviceInLayoutModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    title?: string;
    setIsModalVisible: (visible: boolean) => void;
    existingDevices?: string[];
    layoutBool?: boolean;
    deviceToAdd: Device | null;
}

const AddDeviceInLayoutModal: FC<AddDeviceInLayoutModalProps> = ({
    visible,
    onCancel,
    onOk,
    setIsModalVisible,
    existingDevices,
    layoutBool,
    deviceToAdd,
}) => {
    const { allLayouts, fetchLayouts } = useLayoutsStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [selectedLayout, setSelectedLayout] = useState<LayoutType | null>(null);
    const { user, SmartDVRToken } = useAuthStore();
    console.log(selectedLayout);
    useEffect(() => {
        fetchLayouts();
    }, []);

    const handleOk = async () => {
        try {
            if (!selectedLayout?.uid) {
                message.error('Выберите раскладку.');
                return;
            }

            const deviceInLayout = selectedLayout?.devices?.some((device: Device) => {
                return device.UID === deviceToAdd?.UID;
            });

            console.log(deviceInLayout);

            if (deviceInLayout) {
                message.warning('Это стройство уже есть в выбранной раскладке');
                return;
            }

            const devicesData = [
                ...(selectedLayout?.devices?.map((device) => ({ UID: device.UID! })) || []),
                { UID: deviceToAdd?.UID! },
            ];

            const data = {
                ...selectedLayout,
                devices: devicesData,
            };

            if (user && SmartDVRToken) {
                setLoading(true);
                const response = await UpdateLayouts(SmartDVRToken, user.login, data);

                if (response.success) {
                    message.success(
                        `Добавлено устройство ${deviceToAdd?.name} в раскладку ${selectedLayout?.name}`,
                    );
                    form.resetFields();
                    await fetchLayouts();
                    onOk();
                }
            }
        } catch (error) {
            console.error('Ошибка обновления раскладки:', error);
            message.error('Произошла ошибка при обновлении раскладки.');
        } finally {
            setLoading(false);
        }
    };

    const handleLayoutChange = (value: string) => {
        const layout = allLayouts.find((l) => l.uid === value);
        setSelectedLayout(layout || null);
    };

    return (
        <Modal
            title={
                <div className="titleModal_Layout">
                    <span className="spanLayout">Добавить устройство в раскладку</span>
                    <CloseOutlined onClick={onCancel} className="closeBut_Layout" />
                </div>
            }
            className="add-device-modal_in-layout"
            visible={visible}
            onOk={handleOk}
            onCancel={onCancel}
            // width={720}
            centered={true}
            closable={false}
            footer={
                <Button
                    className="button-size-medium button-type-primary"
                    onClick={handleOk}
                    loading={loading}
                >
                    Добавить
                </Button>
            }
        >
            <Form form={form}>
                <Form.Item
                    className="form_Layout"
                    label={<span className="inputLabel_Layout">Раскладка</span>}
                    name="layout"
                    rules={[{ required: true, message: 'Пожалуйста, выберите раскладку' }]}
                >
                    <Select placeholder="Раскладка" onChange={handleLayoutChange}>
                        {allLayouts?.map((layout) => (
                            <Option key={layout?.uid} value={layout?.uid}>
                                {layout.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddDeviceInLayoutModal;
